// Bridge to the 3D turbine (plug-in "turbine3d", loaded only when its card comes near the screen).
import { st } from './state.js';
import { TURB, COMP, THEME } from './content.js';

var box = null, lazy = null, ctl = null, pending = null, state = 'idle', onPick = null;

export function init3d(container, lazyCfg, pick) {
  box = container; lazy = lazyCfg; onPick = pick;
  if (typeof IntersectionObserver !== 'undefined') {
    var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '600px' });
    io.observe(box);
  } else load();
}

function find() { var P = (window.WFI && window.WFI.plugins) || []; return P.filter(function (p) { return p.id === 'turbine3d'; })[0]; }

function load() {
  if (state !== 'idle') return; state = 'loading';
  var impl = find(); if (impl) return mount(impl);
  if (!lazy || !lazy.script) return fail('The 3D view is not part of this build.');
  if (lazy.css && !document.querySelector('link[data-wf3d]')) { var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = lazy.css; l.setAttribute('data-wf3d', '1'); document.head.appendChild(l); }
  var s = document.createElement('script'); s.src = lazy.script; s.async = true; s.setAttribute('data-no-optimize', '1');
  s.onload = function () { var p = find(); if (p) mount(p); else fail('The 3D view could not start.'); };
  s.onerror = function () { fail('The 3D view could not be loaded.'); };
  document.head.appendChild(s);
}

function mount(impl) {
  try {
    ctl = impl.mount(box, { TURB: TURB, COMP: COMP, THEME: THEME, theme: function () { return st.theme; }, pick: function (id) { if (onPick) onPick(id); } });
    state = 'ready';
    if (pending) { ctl.update(pending); pending = null; }
  } catch (e) { fail('Your browser cannot show the 3D view (WebGL is off or not supported).'); if (window.console) console.warn('3D view', e); }
}
function fail(msg) { state = 'failed'; var m = box.querySelector('.wf-3dmsg'); if (m) m.textContent = msg; }

export function update3d(info, t) {
  var is = t.issue, d = {
    id: t.id, rpm: info.rpm, code: info.T.code[st.h], pitch: info.pitch, yaw: info.yaw, comp: info.comp, fault: is ? is.f.id : null, faultName: is ? is.f.name : '',
    zones: Object.keys(info.m).reduce(function (o, k) { o[k] = { zone: info.m[k].zone, value: info.m[k].value }; return o; }, {}), severity: is ? is.severity : 0, theme: st.theme
  };
  if (ctl) ctl.update(d); else pending = d;
}
export function resize3d() { if (ctl && ctl.resize) ctl.resize(); }
export function focus3d(compId) { if (ctl && ctl.focus) ctl.focus(compId); }
